var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoverVerifyNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 5V67H15V5H51Z",
    fill: "#FDE8F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51 14.1176V5H15V67H33",
    stroke: "#EC187B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 20H76V85H38V20Z",
    fill: "#EC187B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 72.5,
    r: 3,
    fill: "#FDE8F2",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverVerifyNo);
export default __webpack_public_path__ + "static/media/hover-verify-no.9b9866a1a4214b5a74608203831a931c.svg";
export { ForwardRef as ReactComponent };